import React, { useState, useEffect } from 'react'
import { getReports } from '../utils/firestore'
import { GetReportData } from '../utils/api'
import LoadingFullScreen from '../components/loadingFullScreen'
import ReportFragment from '../components/reports/reportFragment'
import { useCallback } from 'react'
import { useSearchParams } from 'next/navigation'

const Dashboard = (props) => {
  const [ currentReport, setCurrentReport ] = useState()
  const [ currentReportData, setCurrentReportData ] = useState()
  const searchParams = useSearchParams()
  const companyId = searchParams.get('companyId')
  const userId = searchParams.get('userId')
  const reportId = searchParams.get('reportId')
 
  
  const getData = useCallback(async () => {
    if(!reportId) return
    
    const reports = await getReports(companyId)
    console.log('Reports Data', reports)
    setCurrentReport(reports.find((i)=>i.id===reportId))

    let grd = await GetReportData(
      reportId,
      companyId,
      userId
    )

    console.log(grd)

    setCurrentReportData(grd)
    //console.log('current report')
    //console.log(reports[0])
  },[reportId,companyId,userId])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      getData()
    }
  }, [getData])

  return (
    <   >
      <div className="md:flex md:items-start md:justify-between px-4 sm:px-6 md:px-8">
        <div className="flex-2 min-w-0">
          <h1 className="text-2xl font-semibold text-gray-900">Financial Reports</h1>
        </div>
      </div>

      {/* Report UI */}
      {/* JSON.stringify(currentReport) */}
      {currentReport && currentReportData &&
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 print:max-w-7xl">
          <div className="py-4">
            {currentReport.settings.structure.map((frag) => <ReportFragment key={frag.type+frag.value} data={frag} authId={userId} report={currentReport} reportData={currentReportData} />)}
          </div>
        </div>
      }

      {!currentReport || !currentReportData &&
        <LoadingFullScreen />
      }

    </>
  )
}

export default Dashboard
